import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import { red500 } from 'material-ui/styles/colors';
import LinearProgress from 'material-ui/LinearProgress';

export default () => (
  <div
    style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <CircularProgress
      mode="indeterminate"
      color={red500}
    />
  </div>
);


// WEBPACK FOOTER //
// ./src/components/ProgressIndicator.js